export const version = "rlp/5.6.0";
//# sourceMappingURL=_version.js.map